import { APICore } from "./apiCore";

const api = new APICore();

function saveQuizQuestion(params: any) {
    const baseUrl = "/api/QuizQuestion/Save";
    return api.create(`${baseUrl}`, params);
}

function getAllQuizQuestion(params: {
    pageNumber: number;
    pageSize: number;
    quizid: number | string;
    filter:string;
    //  query: string;

}) {
    const baseUrl = "/api/QuizQuestion/GetAll";
    return api.get(`${baseUrl}`, params);
}
function getQuizQuestion(params: { id: number | string }) {
    const baseUrl = "/api/QuizQuestion/Get";
    return api.get(`${baseUrl}`, params);
}

const deleteQuizQuestion = (id: any) => {
    const baseUrl = "/api/QuizQuestion/Delete";
    return api.delete(`${baseUrl}?id=${id}`);
  }

export { saveQuizQuestion, getQuizQuestion ,getAllQuizQuestion, deleteQuizQuestion }